import Patterns from '../patterns.js';

export default [
  {
    name: 'title.cs',
    label: {
      cs: 'Nadpis [CS]',
      en: 'Title [CS]',
    },
    type: 'string',
    pattern: Patterns.ALPHANUMERIC,
    patternErrorMessage: Patterns.ALPHANUMERIC_MESSAGE,
    minLength: 2,
    maxLength: 128,
    required: true,
  },
  {
    name: 'title.en',
    label: {
      cs: 'Nadpis [EN]',
      en: 'Title [EN]',
    },
    type: 'string',
    pattern: Patterns.ALPHANUMERIC,
    patternErrorMessage: Patterns.ALPHANUMERIC_MESSAGE,
    minLength: 2,
    maxLength: 128,
    required: true,
  },
  {
    name: 'date',
    label: {
      cs: 'Datum',
      en: 'Date',
    },
    type: 'date',
    required: true,
  },
  {
    name: 'author.firstName',
    label: {
      cs: 'Jméno autora',
      en: 'Author\'s first name',
    },
    type: 'name',
    pattern: Patterns.ONLY_ACCENTS,
    patternErrorMessage: Patterns.ONLY_ACCENTS_MESSAGE,
    minLength: 2,
    maxLength: 32,
    required: true,
  },
  {
    name: 'author.lastName',
    label: {
      cs: 'Příjmení autora',
      en: 'Author\'s last name',
    },
    type: 'name',
    pattern: Patterns.ONLY_ACCENTS,
    patternErrorMessage: Patterns.ONLY_ACCENTS_MESSAGE,
    minLength: 2,
    maxLength: 32,
    required: true,
  },
  {
    name: 'perex.cs',
    label: {
      cs: 'Perex [CS]',
      en: 'Perex [CS]',
    },
    type: 'string',
    minLength: 2,
    maxLength: 512,
    required: true,
  },
  {
    name: 'content.cs',
    label: {
      cs: 'Obsah [CS]',
      en: 'Content [CS]',
    },
    type: 'string',
    minLength: 2,
    maxLength: 6144,
    required: true,
  },
  {
    name: 'perex.en',
    label: {
      cs: 'Perex [EN]',
      en: 'Perex [EN]',
    },
    type: 'string',
    minLength: 2,
    maxLength: 512,
  },
  {
    name: 'content.en',
    label: {
      cs: 'Obsah [EN]',
      en: 'Content [EN]',
    },
    type: 'string',
    minLength: 2,
    maxLength: 6144,
  },
  {
    name: 'year',
    label: {
      cs: 'Ročník',
      en: 'Year',
    },
    type: 'number',
    min: 1900,
    max: 2200,
    required: true,
  },
  {
    name: 'pinned',
    label: {
      cs: 'Připnuto',
      en: 'Pinned',
    },
    type: 'boolean',
    required: true,
  },
  {
    name: 'active',
    label: {
      cs: 'Aktivní',
      en: 'Active',
    },
    type: 'boolean',
    required: true,
  },
];
